/* eslint-disable max-len */
import socket from '../../utils/socket';
import { ForceLogout } from '@bvt-features/auth/component';
import { usePertaminaAsset } from '@bvt-features/pertamina/hooks/usePertaminaAsset';
import { useTenantSuitability } from '@bvt-features/tenant-suitability/hooks/useTenantSuitability';
import { useAreaProfiling } from '@bvt-features/danone/area-profiling/hooks/useAreaProfiling';
import { useAuth } from '@bvt-features/auth/hooks';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SocketProvider() {
  const [isOpen, setOpen] = useState(false);
  const auth = useAuth();
  const pertamina = usePertaminaAsset();
  const tsa = useTenantSuitability();
  const navigate = useNavigate();
  const danone = useAreaProfiling();

  useEffect(() => {
    if (auth.state?.data?.user?.id) {
      socket.connect();
      const dualLoginEvent = 'dual-login-detected-' + auth.state.data.user?.id;
      const notifBulkXlsPertamina = `notification-private-${auth.state.data?.user?.id}-pertamina`;
      const notifBulkPdfPertamina = `notification-private-${auth.state.data?.user?.id}-pertamina-pdf`;
      const notifBulkXlsJaklingko = `notification-private-${auth.state.data?.user?.id}-jaklingko`;
      const notifSummaryDanone = `notification-private-${auth.state.data?.user?.id}-danone-excel-summary`;

      socket.off(dualLoginEvent);
      socket.off(notifBulkXlsPertamina);
      socket.off(notifBulkPdfPertamina);
      socket.off(notifBulkXlsJaklingko);
      socket.off(notifSummaryDanone);

      socket.on(dualLoginEvent, () => {
        setOpen(true);
        auth.doLogout();
      });
      socket.on(notifBulkXlsPertamina, ({ payload }) => {
        pertamina.setStartDownload(true);
        pertamina.setDownloadFilename(payload.filename);
        pertamina.doDownloadBulkResult({
          url: payload.download_url,
          filename: payload.filename,
          status: payload.status,
          message: payload.message,
        });
      });
      socket.on(notifBulkPdfPertamina, ({ payload }) => {
        pertamina.setStartDownload(true);
        pertamina.setDownloadFilename(payload.filename);
        pertamina.doDownloadBulkResult({
          url: payload.download_url,
          filename: payload.filename,
          status: payload.status,
          message: payload.message,
        });
      });
      socket.on(notifBulkXlsJaklingko, ({ payload }) => {
        tsa.setStartDownload(true);
        tsa.setDownloadFilename(payload.filename);
        tsa.doDownloadBulkResult({
          url: payload.download_url,
          filename: payload.filename,
          status: payload.status,
          message: payload.message,
        });
      });
      socket.on(notifSummaryDanone, ({ payload }) => {
        danone.downloadVillageResult({
          url: payload.village_download_url,
          filename: payload.village_filename,
        });
        danone.downloadCatchmentResult({
          url: payload.catchment_download_url,
          filename: payload.catchment_filename,
        });
      });
    }
    return () => {
      socket.disconnect();
    };
  }, [auth.state?.data?.user]);
  return (
    <ForceLogout onSubmit={() => navigate('/auth/logout')} open={isOpen} />
  );
}
